<template>

  <section class="bulk-issue-processing">

    <div class="bulk-issue-processing__icon">
       <i
        class="fas fa-file-signature"
        aria-hidden="true"
      ></i
      >
    </div>

    <div class="bulk-issue-processing__body">
       <strong class="bulk-issue-processing__title">Đang phát hành hàng loạt</strong>
      <p class="bulk-issue-processing__text">
        Hệ thống đang ký số, gửi dữ liệu và cập nhật trạng thái từng hóa đơn.
      </p>
       <b-progress
        :value="progressPercent"
        max="100"
        show-progress
        animated
        variant="primary"
        class="bulk-issue-processing__progress"
      ></b-progress
      >
      <div class="bulk-issue-processing__meta">
         <span>{{ processed }} / {{ total }} đã xử lý</span> <span v-if="currentStepLabel"
          >Bước hiện tại: {{ currentStepLabel }}</span
        >
      </div>

    </div>

  </section>

</template>

<script>
  export default {
    name: 'BulkIssueProcessingState',
    props: {
      progressPercent: {
        type: Number,
        default: 0,
      },
      processed: {
        type: Number,
        default: 0,
      },
      total: {
        type: Number,
        default: 0,
      },
      currentStepLabel: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style scoped>
  .bulk-issue-processing {
    display: flex;
    align-items: flex-start;
    gap: 0.9rem;
    padding: 1rem;
    border: 1px solid #e1e7ef;
    border-radius: 12px;
    background: #fff;
  }

  .bulk-issue-processing__body {
    flex: 1
  }

  .bulk-issue-processing__icon {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #eef4ff;
    color: #187de4;
    flex: 0 0 auto;
  }

  .bulk-issue-processing__title {
    display: block;
    color: #1f2a3d;
    font-size: 0.94rem;
    font-weight: 700;
  }

  .bulk-issue-processing__text {
    margin: 0.25rem 0 0;
    color: #556274;
    font-size: 0.82rem;
    line-height: 1.45;
  }

  .bulk-issue-processing__progress {
    margin-top: 0.75rem;
  }

  .bulk-issue-processing__meta {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 0.45rem;
    color: #6c7788;
    font-size: 0.78rem;
  }

  @media (max-width: 767.98px) {
    .bulk-issue-processing,
    .bulk-issue-processing__meta {
      flex-direction: column;
      align-items: stretch;
    }
  }
</style>
